import { useState } from 'react';

import { IUser } from 'common/components/sharedCustomComponents/userProfileSearchDropdown/UserProfileSearchDropdown';

export function useUserProfileSearchInput(): {
    userInfo: IUser | null,
    handleChangeUserProfile: (e: unknown, userInfo: IUser | null) => void,
    resetUserInfo: () => void,
    } {
    const [ userInfo, setUserInfo ] = useState<IUser | null>(null);

    const resetUserInfo = () => {
        setUserInfo(null);
    };

    const handleChange = (_e: unknown, newUserInfo: IUser | null) => {
        if(newUserInfo)
        {
            setUserInfo({
                id: newUserInfo.id,
                profile: {
                    ...newUserInfo.profile
                }
            });
        } else {
            resetUserInfo();
        }
    };

    return {
        userInfo,
        handleChangeUserProfile: handleChange,
        resetUserInfo
    };
}
